import { Flex, Space, Spacing, Text } from '@billy/design-system'
import React from 'react'
import { Trans } from 'react-i18next'

import * as Styled from './styles'
import { Step } from './types'

interface StepsProps {
  steps: Step[]
}

export const Steps = ({ steps }: StepsProps) => {
  return (
    <Flex flexDirection="column">
      {steps.map(({ number, header, description, components }, index) => (
        <React.Fragment key={number}>
          <Flex gap={Spacing.S24}>
            <Flex flexDirection="column" alignItems="center">
              <Styled.StepNumber>{number}</Styled.StepNumber>
              {index < steps.length - 1 && <Styled.StepLine />}
            </Flex>
            <Flex flexDirection="column" gap={Spacing.S2}>
              <Text variant="bodyLG" weight="bold">
                {header}
              </Text>
              <Text>
                <Trans i18nKey={description} components={components} />
              </Text>
              <Space size="s24" />
            </Flex>
          </Flex>
        </React.Fragment>
      ))}
    </Flex>
  )
}
